import { FC, ReactElement, useEffect, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { SampleDetailed, SampleStatus, SampleWithRequests } from '../types'
import { useTranslation } from 'react-i18next'
import useFormatDate from 'hooks/useFormatDate'
import { parseISO } from 'date-fns'
import { ExportPrevToBotModal } from 'views/pages/Bid/BidDetail/Bid/Samples/PublishSample/PublishToExport/ExportPrevToBotModal'
import { ExportToBotModal } from 'views/pages/Bid/BidDetail/Bid/Samples/PublishSample/PublishToExport/ExportToBotModal'

type Props = {
  sample: SampleDetailed | SampleWithRequests
  onSucess: () => Promise<void>
}

export const ExportBotWrapper: FC<Props> = ({ sample, onSucess }) => {
  const { t } = useTranslation('samples')
  const formatDate = useFormatDate()
  const [showExportModal, setShowExportModal] = useState(false)
  const [showHistoryData, setShowHistoryData] = useState(false)

  useEffect(() => {
    if (!sample) return
    setShowHistoryData(!!sample.sent_to_export_bot_date)
  }, [sample])

  if (!sample) return <></>

  const onClose = () => {
    setShowExportModal(false)
    setShowHistoryData(!!sample.sent_to_export_bot_date)
  }

  let btn: ReactElement | null = null
  if (sample.can_be_send_to_export_bot) {
    btn = (
      <AButton id="sendToExportChat" color="secondary" size="medium" onClick={() => setShowExportModal(true)}>
        {t('sendToExportChat')}
      </AButton>
    )
  } else if (sample.can_be_send_to_export_bot_date && parseISO(sample.can_be_send_to_export_bot_date) > new Date()) {
    btn = (
      <AButton id="sendToExportChatPlaceholder" color="secondary" size="medium" disabled>
        {`${t('samples:nextSendToTelegramAt')}: ${formatDate(sample.can_be_send_to_export_bot_date)}`}
      </AButton>
    )
  } else if (sample.status == SampleStatus.published && sample.cant_be_send_to_export_bot_reason) {
    btn = (
      <AButton id="sendToExportChatPlaceholder" color="secondary" size="medium" disabled>
        {sample.cant_be_send_to_export_bot_reason}
      </AButton>
    )
  }
  return (
    <>
      {btn}
      {showExportModal &&
        (showHistoryData ? (
          <ExportPrevToBotModal
            sample={sample}
            onSuccess={onSucess}
            onClose={onClose}
            setShowHistoryData={setShowHistoryData}
          />
        ) : (
          <ExportToBotModal sample={sample} onSuccess={onSucess} onClose={onClose} />
        ))}
    </>
  )
}
